import { createApi } from '@reduxjs/toolkit/query/react';
import { authBaseQuery } from '../../app/axiosBaseQuery';
import { PaginationResult } from '../../types/global.d';
import { MergedHistory, HistoryType, PresentationMergedHistoryRequest } from '../types/models/MergedHistory';
import {createNormalizationMiddleware} from "../../app/normy/normyRtkQuery.ts";

export const MERGED_HISTORY_API_REDUCER_KEY = 'merged-histories';
export const MERGED_HISTORY_PATH = 'merged-histories';

export interface MergedHistoryQueryParams {
    page: number;
    pageSize: number;
    action?: string;
    updatedAtFrom?: Date;
    updatedAtTo?: Date;
    cuttingId?: string;
    storageId?: string;
    historyTypes?: HistoryType[];
}

export const mergedHistoryApi = createApi({
    reducerPath: MERGED_HISTORY_API_REDUCER_KEY,
    baseQuery: authBaseQuery(),
    keepUnusedDataFor: 10,
    refetchOnMountOrArgChange: 10,
    refetchOnFocus: true,
    tagTypes: ['MergedHistory', 'MergedHistories'],
    endpoints: (builder) => ({
        getMergedHistoryPresentation: builder.query<PaginationResult<MergedHistory>, MergedHistoryQueryParams>({
            query: (params) => {
                const page = params.page ?? 0;
                const pageSize = params.pageSize ?? 50;
                const body: PresentationMergedHistoryRequest = {
                    list: { page, pageSize },
                    action: params.action,
                    updatedAtFrom: params.updatedAtFrom,
                    updatedAtTo: params.updatedAtTo,
                    cuttingId: params.cuttingId,
                    storageId: params.storageId,
                    historyTypes: params.historyTypes,
                };
                return ({
                    url: `/${ MERGED_HISTORY_PATH }/presentation?page=${page}&pageSize=${pageSize}`,
                    method: 'POST',
                    data: body,
                })
            },
            providesTags: ['MergedHistories'],
        }),
    }),
});

export const [mergedHistoryNormalizer, mergedHistoryNormalizerMiddleware] = createNormalizationMiddleware(MERGED_HISTORY_API_REDUCER_KEY, mergedHistoryApi, {
    primaryKey: ['id'],
    normalizeStrategy: 'replace',
});

export const {
    useGetMergedHistoryPresentationQuery,
} = mergedHistoryApi;